import { QueryKey, UseQueryOptions, useQuery } from "@tanstack/react-query";
import { MAG_HOME_END_POINTS } from "core/constants/endpoints";
import instance from "core/constants/request";
import { ResponseDTO } from "interface";
import { article } from "pages/articles/type";

type QueryType = {
  articleLine: number;
};
type QueryOptionsType = UseQueryOptions<
  ResponseDTO<article[]>,
  QueryType,
  ResponseDTO<article[]>
>;

const listFn = async (query: QueryKey): Promise<ResponseDTO<article[]>> => {
  const [{ articleLine }] = query as QueryType[];

  const res = await instance.get(
    `${MAG_HOME_END_POINTS.article_line_articles_list}?line=${articleLine}`
  );

  return res;
};

export const useListArticleLineArticles = (options?: QueryOptionsType) =>
  useQuery({
    queryKey: [MAG_HOME_END_POINTS.article_line_articles_list],
    queryFn: ({ queryKey }) => listFn(queryKey),
    ...options,
  });
